import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import HomebuyerChecklist from "@/pages/HomebuyerChecklist";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/checklist")({
  head: () => seoHead("/checklist"),
  component: () => (
    <AuthGate><HomebuyerChecklist /></AuthGate>
  ),
});
